module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Course Resources"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Resources are additional course materials (articles, links, etc) to further aid you.'),
      expression: "'Resources are additional course materials (articles, links, etc) to further aid you.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), (_vm.resources) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('ul', _vm._l((_vm.resources), function(course) {
    return _c('li', {
      class: {
        'active': _vm.filters.indexOf(course.id) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleSelect(course.id)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(course.name) + "\n                ")])
  }))]), _vm._v(" "), _vm._l((_vm.resources), function(course) {
    return (_vm.filters.length === 0 || _vm.filters.indexOf(course.id) > -1) ? _c('div', {
      staticClass: "resource-table"
    }, [_c('h3', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(course.name))]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((course.files), function(file) {
      return _c('tr', [_c('td', {
        staticClass: "resource-name"
      }, [(file.url.includes('amazonaws')) ? _c('a', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.downloadFile(file.url, file.id)
          }
        }
      }, [_vm._v(_vm._s(file.name))]) : _c('a', {
        attrs: {
          "href": file.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(file.name))])]), _vm._v(" "), _c('td', {
        staticClass: "resource-description"
      }, [_vm._v(_vm._s(file.description))]), _vm._v(" "), _c('td', {
        staticClass: "resource-added"
      }, [_vm._v(_vm._s(_vm._f("localDate")(file.createdAt)))]), _vm._v(" "), _c('td', {
        staticClass: "resource-week"
      }, [_vm._v(_vm._s(file.week))])])
    }))])]) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "resource-name"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "resource-description"
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "resource-added"
  }, [_vm._v("Added")]), _vm._v(" "), _c('th', {
    staticClass: "resource-week"
  }, [_vm._v("Week")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ddeb1eb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources.vue
// module id = 2000
// module chunks = 2